import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import moment from 'moment';

// Selectors
import { makeSelectSharedEventValue } from '../../../../services/sharedEvent/selectors';

interface Props {
    endDate: ?string;
}

export class SharedEventEndDate extends React.PureComponent<Props> {
    render() {
        const { endDate } = this.props;
        if (!endDate) return null;
        return moment(endDate, 'YYYY-MM-DD').format('MMM D');
    }
}

const mapStateToProps = createStructuredSelector({
    endDate: makeSelectSharedEventValue('endDate')
});

export default connect(mapStateToProps)(SharedEventEndDate);
